import { Tabs, Select } from "antd";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
	InternshipEngagementType,
	InternshipType,
	ProfessorProposalReportDTO,
	Role,
	StudentYearEnum,
	StudyProgramDTO,
} from "../../Api";
import {
	getMissingStudentPracticeInternshipEnrollmentReport,
	getMissingStudentProjectEnrollmentReport,
	getPracticeInternshipAllocationReport,
	getPracticeInternshipPerDomainReport,
	getProfessorProposalReport,
	getProjectAllocationReport,
	getStudentAllocationPerDomainReport,
	getSummerSchoolsReport,
} from "../../Requests/report-requests";
import {
	getAllFaculties,
	getFacultyForUser,
} from "../../Requests/faculty-requests";
import ReportTable from "./ReportTable";
import { useQuery } from "react-query";
import {
	getReportStudyPrograms,
	getStudyProgramsForFaculties,
} from "../../Requests/student-study-requests";
import {
	NOTIFICATION_TYPES,
	openNotification,
} from "../Notifications/NotificationsUtils";
import {
	getMissingStudentPracticeInternshipEnrollmentReportInfo,
	getMissingStudentProjectEnrollmentReportInfo,
	getPracticeInternshipAllocationReportInfo,
	getPracticeInternshipPerDomainReportInfo,
	getProfessorProposalReportInfo,
	getPrograms,
	getFaculties,
	getProjectAllocationReportInfo,
	getStudentAllocationPerDomainReportInfo,
	getSummerSchoolReportInfo,
} from "../../utils/reactQueriesConstants";
import { Link, useHistory, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { studentIdSet } from "../Student/StudentSlice";
import {
	useBeforeRender,
	useIsFacultyAdmin,
	useIsDean,
	useIsDepartmentDirector,
	useIsAdmin,
	getCurrentUniversityYear,
	getUserId,
} from "../../utils/utilFunctions";
import { useFeatureFlags } from "../../utils/featureFlags";
import { getProfessorById } from "../../Requests/academic-user-requests";
import { getDepartmentsForFaculties } from "../../Requests/department-requests";
import { emptyGuid } from "../../utils/constants";

const { TabPane } = Tabs;
const { Option } = Select;

type StudyCycle = "Bachelor" | "Master";

const Report = () => {
	const { t } = useTranslation();
	const {
		isAcademicUsersMasterInternshipEnabled,
		isAcademicUsersBachelorInternshipEnabled,
		isAcademicUsersSummerSchoolEnabled,
	} = useFeatureFlags();
	const [tab, setTab] = useState(
		isAcademicUsersMasterInternshipEnabled ||
			isAcademicUsersBachelorInternshipEnabled
			? "1"
			: "4"
	);
	const [studyCycle, setStudyCycle] = useState<StudyCycle>("Bachelor");
	const [studyProgram, setStudyProgram] = useState([]);
	const [selectedYear, setSelectedYear] = useState(getCurrentUniversityYear());
	const [internshipType, setInternshipType] = useState<InternshipType | null>(
		tab === "5" || tab === "7" ? null : InternshipType.ByProfessor
	);
	const [practiceStudyYear, setPracticeStudyYear] = useState<StudentYearEnum>(
		StudentYearEnum.L3
	);
	const [practiceStudyProgram, setPracticeStudyProgram] = useState<
		string | undefined
	>(undefined);
	const [allocatedProjectsStudyProgram, setAllocatedProjectsStudyProgram] =
		useState<string | undefined>(undefined);
	const [filteredPrograms, setFilteredPrograms] = useState<StudyProgramDTO[]>(
		[]
	);
	const isDean = useIsDean();
	const isFacultyAdmin = useIsFacultyAdmin();
	const isDepartmentDirector = useIsDepartmentDirector();
	const isAdmin = useIsAdmin();
	const location = useLocation();
	const history = useHistory();
	const dispatch = useDispatch();

	const [selectedDepartments, setSelectedDepartments] =
		useState<string>(emptyGuid);
	const [selectedStudyCycle, setSelectedStudyCycle] = useState<
		"All" | "Bachelor" | "Master"
	>("All");

	const [selectedFaculty, setSelectedFaculty] = useState<string | undefined>(
		undefined
	);

	const goToStudentProfile = (id: any) => {
		dispatch(studentIdSet(id));
		history.push("/student");
	};

	const professorReportColumns = (t: (text: string) => string) => [
		{
			title: t("reports.professionalTitle"),
			key: "professionalTitle",
			hidden: window.innerWidth < 550,
			// sorter: (
			// 	a: ProfessorProposalReportDTO,
			// 	b: ProfessorProposalReportDTO
			// ) => {
			// 	if (!a.professionalTitle || !b.professionalTitle) return -1;
			// 	return a.professionalTitle.localeCompare(b.professionalTitle);
			// },
			render: (
				text: string | undefined,
				record: ProfessorProposalReportDTO
			) => {
				return (
					<span>{t("professionalTitle." + record.professionalTitle)}</span>
				);
			},
		},
		{
			title: t("reports.name"),
			key: "name",
			// sorter: (
			// 	a: ProfessorProposalReportDTO,
			// 	b: ProfessorProposalReportDTO
			// ) => {
			// 	if (!a.name || !b.name) return -1;
			// 	return a.name.localeCompare(b.name);
			// },
			render: (_text: string | undefined, record: any) => (
				<Link
					to={{
						pathname: `/profil`,
						state: {
							id: record.id,
							userType: Role.Professor,
							origin: location.pathname,
							activeTab: tab,
						},
					}}
				>
					<b>{record.name}</b>
				</Link>
			),
		},
		{
			title: t("reports.department"),
			key: "department",
			hidden: window.innerWidth < 430,
			// sorter: (
			// 	a: ProfessorProposalReportDTO,
			// 	b: ProfessorProposalReportDTO
			// ) => {
			// 	if (!a.department || !b.department) return -1;
			// 	return a.department.localeCompare(b.department);
			// },
		},
		{
			title: t("reports.email"),
			key: "email",
			hidden: window.innerWidth < 975,
			// sorter: (
			// 	a: ProfessorProposalReportDTO,
			// 	b: ProfessorProposalReportDTO
			// ) => {
			// 	if (!a.email || !b.email) return -1;
			// 	return a.email.localeCompare(b.email);
			// },
		},
		{
			title: t("reports.totalAvailablePositions"),
			key: "totalAvailablePositions",
			// sorter: (
			// 	a: ProfessorProposalReportDTO,
			// 	b: ProfessorProposalReportDTO
			// ) => {
			// 	if (!a.totalAvailablePositions || !b.totalAvailablePositions) return -1;
			// 	return a.totalAvailablePositions - b.totalAvailablePositions;
			// },
		},
		{
			title: t("reports.totalAllocatedPositions"),
			key: "totalAllocatedPositions",
			// sorter: (
			// 	a: ProfessorProposalReportDTO,
			// 	b: ProfessorProposalReportDTO
			// ) => {
			// 	if (!a.totalAllocatedPositions || !b.totalAllocatedPositions) return -1;
			// 	return a.totalAllocatedPositions - b.totalAllocatedPositions;
			// },
		},
		{
			title: t("reports.totalAvailablePositionsAsCoTutor"),
			key: "totalAvailablePositionsAsCoTutor",
			hidden: window.innerWidth < 740,
			// sorter: (
			// 	a: ProfessorProposalReportDTO,
			// 	b: ProfessorProposalReportDTO
			// ) => {
			// 	if (
			// 		!a.totalAvailablePositionsAsCoTutor ||
			// 		!b.totalAvailablePositionsAsCoTutor
			// 	)
			// 		return -1;
			// 	return (
			// 		a.totalAvailablePositionsAsCoTutor -
			// 		b.totalAvailablePositionsAsCoTutor
			// 	);
			// },
		},
		{
			title: t("reports.totalAllocatedPositionsAsCoTutor"),
			key: "totalAllocatedPositionsAsCoTutor",
			hidden: window.innerWidth < 740,
			// sorter: (
			// 	a: ProfessorProposalReportDTO,
			// 	b: ProfessorProposalReportDTO
			// ) => {
			// 	if (
			// 		!a.totalAllocatedPositionsAsCoTutor ||
			// 		!b.totalAllocatedPositionsAsCoTutor
			// 	)
			// 		return -1;
			// 	return (
			// 		a.totalAllocatedPositionsAsCoTutor -
			// 		b.totalAllocatedPositionsAsCoTutor
			// 	);
			// },
		},
	];

	const missingStudentProjectEnrollmentReportColumns = (
		t: (text: string) => string
	) => [
		{
			title: t("reports.name"),
			key: "name",
			fixed: "left" as "left",
			// sorter: (
			// 	a: MissingStudentEnrollmentReportDTO,
			// 	b: MissingStudentEnrollmentReportDTO
			// ) => {
			// 	if (!a.name || !b.name) return -1;
			// 	return a.name.localeCompare(b.name);
			// },
			render: (text: string | undefined, record: any) => (
				<a onClick={() => goToStudentProfile(record.id)}>
					<b>{text}</b>
				</a>
			),
		},
		...(isAdmin
			? [
					{
						title: t("reports.faculty"),
						key: "faculty",
					},
			  ]
			: []),
		{
			title: t("reports.studyProgram"),
			key: "studyProgram",
			// sorter: (
			// 	a: MissingStudentEnrollmentReportDTO,
			// 	b: MissingStudentEnrollmentReportDTO
			// ) => {
			// 	if (!a.studyProgram || !b.studyProgram) return -1;
			// 	return a.studyProgram.localeCompare(b.studyProgram);
			// },
		},
		{
			title: t("reports.email"),
			key: "email",
			hidden: window.innerWidth < 650,
			// sorter: (
			// 	a: MissingStudentEnrollmentReportDTO,
			// 	b: MissingStudentEnrollmentReportDTO
			// ) => {
			// 	if (!a.email || !b.email) return -1;
			// 	return a.email.localeCompare(b.email);
			// },
		},
		{
			title: t("reports.applications"),
			key: "applications",
			// sorter: (
			// 	a: MissingStudentEnrollmentReportDTO,
			// 	b: MissingStudentEnrollmentReportDTO
			// ) => {
			// 	if (!a.applications || !b.applications) return -1;
			// 	return a.applications - b.applications;
			// },
		},
	];

	const missingStudentPracticeEnrollmentReportColumns = (
		t: (text: string) => string
	) => [
		{
			title: t("reports.name"),
			key: "name",
			fixed: "left" as "left",
			// sorter: (
			// 	a: MissingStudentEnrollmentReportDTO,
			// 	b: MissingStudentEnrollmentReportDTO
			// ) => {
			// 	if (!a.name || !b.name) return -1;
			// 	return a.name.localeCompare(b.name);
			// },
			render: (text: string | undefined, record: any) => (
				<a onClick={() => goToStudentProfile(record.id)}>
					<b>{text}</b>
				</a>
			),
		},
		{
			title: t("reports.studyProgram"),
			key: "studyProgram",
			// sorter: (
			// 	a: MissingStudentEnrollmentReportDTO,
			// 	b: MissingStudentEnrollmentReportDTO
			// ) => {
			// 	if (!a.studyProgram || !b.studyProgram) return -1;
			// 	return a.studyProgram.localeCompare(b.studyProgram);
			// },
		},
		{
			title: t("reports.group"),
			key: "group",
			// sorter: (
			// 	a: MissingStudentEnrollmentReportDTO,
			// 	b: MissingStudentEnrollmentReportDTO
			// ) => {
			// 	if (!a.group || !b.group) return -1;
			// 	return a.group.localeCompare(b.group);
			// },
		},
		{
			title: t("reports.phone"),
			key: "phone",
			// sorter: (
			// 	a: MissingStudentEnrollmentReportDTO,
			// 	b: MissingStudentEnrollmentReportDTO
			// ) => {
			// 	if (!a.phone || !b.phone) return -1;
			// 	return a.phone.localeCompare(b.phone);
			// },
		},
		{
			title: t("reports.email"),
			key: "email",
			hidden: window.innerWidth < 650,
			// sorter: (
			// 	a: MissingStudentEnrollmentReportDTO,
			// 	b: MissingStudentEnrollmentReportDTO
			// ) => {
			// 	if (!a.email || !b.email) return -1;
			// 	return a.email.localeCompare(b.email);
			// },
		},
		{
			title: t("reports.applications"),
			key: "applications",
			// sorter: (
			// 	a: MissingStudentEnrollmentReportDTO,
			// 	b: MissingStudentEnrollmentReportDTO
			// ) => {
			// 	if (!a.applications || !b.applications) return -1;
			// 	return a.applications - b.applications;
			// },
		},
	];

	const projectAllocationReportColumns = (t: (text: string) => string) => [
		{
			title: t("reports.studentName"),
			key: "studentName",
			fixed: "left" as "left",
			// sorter: (
			// 	a: ProjectAllocationReportDTO,
			// 	b: ProjectAllocationReportDTO
			// ) => {
			// 	if (!a.studentName || !b.studentName) return -1;
			// 	return a.studentName.localeCompare(b.studentName);
			// },
			render: (text: string | undefined, record: any) => (
				<a onClick={() => goToStudentProfile(record.studentId)}>
					<b>{text}</b>
				</a>
			),
		},
		{
			title: t("reports.professorName"),
			key: "professorName",
			// sorter: (
			// 	a: ProjectAllocationReportDTO,
			// 	b: ProjectAllocationReportDTO
			// ) => {
			// 	if (!a.professorName || !b.professorName) return -1;
			// 	return a.professorName.localeCompare(b.professorName);
			// },
			render: (_text: string | undefined, record: any) => (
				<Link
					to={{
						pathname: `/profil`,
						state: {
							id: record.professorId,
							userType: Role.Professor,
							origin: location.pathname,
							activeTab: tab,
						},
					}}
				>
					<b>{record.professorName}</b>
				</Link>
			),
		},
		{
			title: t("reports.projectName"),
			key: "projectName",
			// sorter: (
			// 	a: ProjectAllocationReportDTO,
			// 	b: ProjectAllocationReportDTO
			// ) => {
			// 	if (!a.projectName || !b.projectName) return -1;
			// 	return a.projectName.localeCompare(b.projectName);
			// },
			render: (_text: string | undefined, record: any) => (
				<Link
					to={{
						pathname: "/propunere/" + record.projectId,
						search: "?type=" + record.projectType,
						state: {
							id: record.projectId,
							type: record.projectType,
							origin: location.pathname,
							activeTab: tab,
						},
					}}
				>
					<b>{record.projectName}</b>
				</Link>
			),
		},
		{
			title: t("reports.studentStudyProgram"),
			key: "studentStudyProgram",
			hidden: window.innerWidth < 440,
			// sorter: (
			// 	a: ProjectAllocationReportDTO,
			// 	b: ProjectAllocationReportDTO
			// ) => {
			// 	if (!a.studentStudyProgram || !b.studentStudyProgram) return -1;
			// 	return a.studentStudyProgram.localeCompare(b.studentStudyProgram);
			// },
		},
		{
			title: t("reports.studentEmail"),
			key: "studentEmail",
			hidden: window.innerWidth < 700,
			// sorter: (
			// 	a: ProjectAllocationReportDTO,
			// 	b: ProjectAllocationReportDTO
			// ) => {
			// 	if (!a.studentEmail || !b.studentEmail) return -1;
			// 	return a.studentEmail.localeCompare(b.studentEmail);
			// },
		},
		{
			title: t("reports.professorDepartment"),
			key: "professorDepartment",
			hidden: window.innerWidth < 880,
			// sorter: (
			// 	a: ProjectAllocationReportDTO,
			// 	b: ProjectAllocationReportDTO
			// ) => {
			// 	if (!a.professorDepartment || !b.professorDepartment) return -1;
			// 	return a.professorDepartment.localeCompare(b.professorDepartment);
			// },
		},
		{
			title: t("reports.professorEmail"),
			key: "professorEmail",
			hidden: window.innerWidth < 700,
			// sorter: (
			// 	a: ProjectAllocationReportDTO,
			// 	b: ProjectAllocationReportDTO
			// ) => {
			// 	if (!a.professorEmail || !b.professorEmail) return -1;
			// 	return a.professorEmail.localeCompare(b.professorEmail);
			// },
		},
		{
			title: t("reports.coTutorName"),
			key: "coTutorName",
			hidden: window.innerWidth < 880,
			// sorter: (
			// 	a: ProjectAllocationReportDTO,
			// 	b: ProjectAllocationReportDTO
			// ) => {
			// 	if (!a.coTutorName || !b.coTutorName) return -1;
			// 	return a.coTutorName.localeCompare(b.coTutorName);
			// },
		},
	];

	const summerSchoolsReportColumns = (t: (text: string) => string) => [
		{
			title: t("reports.summerSchoolName"),
			key: "summerSchoolName",
			fixed: "left" as "left",
			// sorter: (a: SummerSchoolsReportDTO, b: SummerSchoolsReportDTO) => {
			// 	if (!a.summerSchoolName || !b.summerSchoolName) return -1;
			// 	return a.summerSchoolName.localeCompare(b.summerSchoolName);
			// },
			render: (_text: string | undefined, record: any) => (
				<Link
					to={{
						pathname: "/propunere/" + record.summerSchoolId,
						search: "?type=" + record.summerSchoolType,
						state: {
							id: record.summerSchoolId,
							type: record.summerSchoolType,
							origin: location.pathname,
							activeTab: tab,
						},
					}}
				>
					<b>{record.summerSchoolName}</b>
				</Link>
			),
		},
		{
			title: t("reports.coTutorName"),
			key: "coTutorName",
			// sorter: (a: SummerSchoolsReportDTO, b: SummerSchoolsReportDTO) => {
			// 	if (!a.coTutorName || !b.coTutorName) return -1;
			// 	return a.coTutorName.localeCompare(b.coTutorName);
			// },
		},
		{
			title: t("reports.totalAvailablePositions"),
			key: "totalAvailablePositions",
			// sorter: (a: SummerSchoolsReportDTO, b: SummerSchoolsReportDTO) => {
			// 	if (!a.totalAvailablePositions || !b.totalAvailablePositions) return -1;
			// 	return a.totalAvailablePositions - b.totalAvailablePositions;
			// },
		},
		{
			title: t("reports.totalAllocatedPositions"),
			key: "totalAllocatedPositions",
			// sorter: (a: SummerSchoolsReportDTO, b: SummerSchoolsReportDTO) => {
			// 	if (!a.totalAllocatedPositions || !b.totalAllocatedPositions) return -1;
			// 	return a.totalAllocatedPositions - b.totalAllocatedPositions;
			// },
		},
	];

	const practiceInternshipAllocationReportColumns = (
		t: (text: string) => string
	) => [
		{
			title: t("reports.name"),
			key: "name",
			fixed: "left" as "left",
			// sorter: (
			// 	a: PracticeInternshipAllocationReportDTO,
			// 	b: PracticeInternshipAllocationReportDTO
			// ) => {
			// 	if (!a.name || !b.name) return -1;
			// 	return a.name.localeCompare(b.name);
			// },
			render: (text: string | undefined, record: any) => (
				<a onClick={() => goToStudentProfile(record.id)}>
					<b>{text}</b>
				</a>
			),
		},
		{
			title: t("reports.faculty"),
			key: "faculty",
			hidden: window.innerWidth < 500,
			// sorter: (
			// 	a: PracticeInternshipAllocationReportDTO,
			// 	b: PracticeInternshipAllocationReportDTO
			// ) => {
			// 	if (!a.faculty || !b.faculty) return -1;
			// 	return a.faculty.localeCompare(b.faculty);
			// },
		},
		{
			title: t("reports.studyProgram"),
			key: "studyProgram",
			hidden: window.innerWidth < 440,
			// sorter: (
			// 	a: PracticeInternshipAllocationReportDTO,
			// 	b: PracticeInternshipAllocationReportDTO
			// ) => {
			// 	if (!a.studyProgram || !b.studyProgram) return -1;
			// 	return a.studyProgram.localeCompare(b.studyProgram);
			// },
		},
		{
			title: t("reports.department"),
			key: "department",
			hidden: window.innerWidth < 600,
			// sorter: (
			// 	a: PracticeInternshipAllocationReportDTO,
			// 	b: PracticeInternshipAllocationReportDTO
			// ) => {
			// 	if (!a.department || !b.department) return -1;
			// 	return a.department.localeCompare(b.department);
			// },
		},
		{
			title: t("reports.email"),
			key: "email",
			hidden: window.innerWidth < 700,
			// sorter: (
			// 	a: PracticeInternshipAllocationReportDTO,
			// 	b: PracticeInternshipAllocationReportDTO
			// ) => {
			// 	if (!a.email || !b.email) return -1;
			// 	return a.email.localeCompare(b.email);
			// },
		},
		{
			title: t("reports.phone"),
			key: "phone",
			hidden: window.innerWidth < 800,
			// sorter: (
			// 	a: PracticeInternshipAllocationReportDTO,
			// 	b: PracticeInternshipAllocationReportDTO
			// ) => {
			// 	if (!a.phone || !b.phone) return -1;
			// 	return a.phone.localeCompare(b.phone);
			// },
		},
		{
			title: t("reports.group"),
			key: "group",
			hidden: window.innerWidth < 900,
			// sorter: (
			// 	a: PracticeInternshipAllocationReportDTO,
			// 	b: PracticeInternshipAllocationReportDTO
			// ) => {
			// 	if (!a.group || !b.group) return -1;
			// 	return a.group.localeCompare(b.group);
			// },
		},
		{
			title: t("reports.applications"),
			key: "applications",
			// sorter: (
			// 	a: PracticeInternshipAllocationReportDTO,
			// 	b: PracticeInternshipAllocationReportDTO
			// ) => {
			// 	if (!a.applications || !b.applications) return -1;
			// 	return a.applications - b.applications;
			// },
		},
	];

	const studentAllocationPerDomainReportColumns = (
		t: (text: string) => string
	) => [
		{
			title: t("reports.studyProgram"),
			key: "fieldOfStudy",
			// sorter: (
			// 	a: StudentsPerDomainReportDTO,
			// 	b: StudentsPerDomainReportDTO
			// ) => {
			// 	if (!a.fieldOfStudy || !b.fieldOfStudy) return -1;
			// 	return a.fieldOfStudy.localeCompare(b.fieldOfStudy);
			// },
		},
		{
			title: t("reports.year"),
			key: "year",
			// sorter: (
			// 	a: StudentsPerDomainReportDTO,
			// 	b: StudentsPerDomainReportDTO
			// ) => {
			// 	if (!a.year || !b.year) return -1;
			// 	return a.year.localeCompare(b.year);
			// },
		},
		{
			title: t("reports.totalStudents"),
			key: "totalStudents",
			// sorter: (
			// 	a: StudentsPerDomainReportDTO,
			// 	b: StudentsPerDomainReportDTO
			// ) => {
			// 	if (!a.totalStudents || !b.totalStudents) return -1;
			// 	return a.totalStudents - b.totalStudents;
			// },
		},
		{
			title: t("reports.applyingStudents"),
			key: "applyingStudents",
			// sorter: (
			// 	a: StudentsPerDomainReportDTO,
			// 	b: StudentsPerDomainReportDTO
			// ) => {
			// 	if (!a.applyingStudents || !b.applyingStudents) return -1;
			// 	return a.applyingStudents - b.applyingStudents;
			// },
		},
		{
			title: t("reports.applicationAcceptedStudents"),
			key: "applicationAcceptedStudents",
			// sorter: (
			// 	a: StudentsPerDomainReportDTO,
			// 	b: StudentsPerDomainReportDTO
			// ) => {
			// 	if (!a.applicationAcceptedStudents || !b.applicationAcceptedStudents)
			// 		return -1;
			// 	return a.applicationAcceptedStudents - b.applicationAcceptedStudents;
			// },
		},
		{
			title: t("reports.offerAcceptedStudents"),
			key: "offerAcceptedStudents",
			// sorter: (
			// 	a: StudentsPerDomainReportDTO,
			// 	b: StudentsPerDomainReportDTO
			// ) => {
			// 	if (!a.offerAcceptedStudents || !b.offerAcceptedStudents) return -1;
			// 	return a.offerAcceptedStudents - b.offerAcceptedStudents;
			// },
		},
	];

	const practiceInternshipsPerDomainReportColumns = (
		t: (text: string) => string
	) => [
		{
			title: t("reports.studyProgram"),
			key: "fieldOfStudy",
			// sorter: (
			// 	a: PracticeInternshipsPerDomainReportDTO,
			// 	b: PracticeInternshipsPerDomainReportDTO
			// ) => {
			// 	if (!a.fieldOfStudy || !b.fieldOfStudy) return -1;
			// 	return a.fieldOfStudy.localeCompare(b.fieldOfStudy);
			// },
		},
		{
			title: t("reports.totalInternships"),
			key: "totalInternships",
			// sorter: (
			// 	a: PracticeInternshipsPerDomainReportDTO,
			// 	b: PracticeInternshipsPerDomainReportDTO
			// ) => {
			// 	if (!a.totalInternships || !b.totalInternships) return -1;
			// 	return a.totalInternships - b.totalInternships;
			// },
		},
		{
			title: t("reports.totalInitialPositions"),
			key: "totalInitialPositions",
			// sorter: (
			// 	a: PracticeInternshipsPerDomainReportDTO,
			// 	b: PracticeInternshipsPerDomainReportDTO
			// ) => {
			// 	if (!a.totalInitialPositions || !b.totalInitialPositions) return -1;
			// 	return a.totalInitialPositions - b.totalInitialPositions;
			// },
		},
		{
			title: t("reports.totalAvailablePositions"),
			key: "totalAvailablePositions",
			// sorter: (
			// 	a: PracticeInternshipsPerDomainReportDTO,
			// 	b: PracticeInternshipsPerDomainReportDTO
			// ) => {
			// 	if (!a.totalAvailablePositions || !b.totalAvailablePositions) return -1;
			// 	return a.totalAvailablePositions - b.totalAvailablePositions;
			// },
		},
		{
			title: t("reports.averageNumberPositionsPerEmployer"),
			key: "averageNumberPositionsPerEmployer",
			// sorter: (
			// 	a: PracticeInternshipsPerDomainReportDTO,
			// 	b: PracticeInternshipsPerDomainReportDTO
			// ) => {
			// 	if (
			// 		!a.averageNumberPositionsPerEmployer ||
			// 		!b.averageNumberPositionsPerEmployer
			// 	)
			// 		return -1;
			// 	return (
			// 		a.averageNumberPositionsPerEmployer -
			// 		b.averageNumberPositionsPerEmployer
			// 	);
			// },
			render: (value: number | undefined) => {
				if (value === undefined || value === null) {
					return "-";
				}
				return Number(value).toFixed(2);
			},
		},
	];

	const openErrorNotification = (error: string, message: string) => {
		openNotification(error, message, NOTIFICATION_TYPES.ERROR);
	};

	const { data: faculties } = useQuery(
		[getFaculties],
		() => getAllFaculties(),
		{
			refetchOnWindowFocus: false,
			onError: () =>
				openErrorNotification(
					t("reports.errorTexts.loadingFailed"),
					t("reports.errorTexts.loadingFailedMessage")
				),
		}
	);

	// Query pentru datele utilizatorului curent (pentru prefiltrare)
	const { data: currentUser } = useQuery(
		["getCurrentUserForReport", isFacultyAdmin, isDean, isDepartmentDirector],
		() => {
			if (isFacultyAdmin || isDean || isDepartmentDirector) {
				return getProfessorById(getUserId());
			}
			return null;
		},
		{
			refetchOnWindowFocus: false,
			enabled: isFacultyAdmin || isDean || isDepartmentDirector,
		}
	);

	// Query pentru departamente (dinamic pe baza facultății selectate)
	const { data: departmentsData } = useQuery(
		["getDepartmentsForFacultiesForReport", selectedFaculty, isAdmin, isDean],
		() => {
			if ((isAdmin || isDean) && selectedFaculty) {
				return getDepartmentsForFaculties([selectedFaculty]);
			}
			return null;
		},
		{
			refetchOnWindowFocus: false,
			enabled: (isAdmin && !!selectedFaculty) || (isDean && !!selectedFaculty),
		}
	);

	const { data: facultyForUser } = useQuery(
		["getFacultyForUser", getUserId()],
		() => getFacultyForUser(),
		{
			enabled: !selectedFaculty,
			refetchOnWindowFocus: false,
			staleTime: 5 * 60 * 1000,
			onError: () =>
				openErrorNotification(
					t("reports.errorTexts.loadingFailed"),
					t("reports.errorTexts.loadingFailedMessage")
				),
		}
	);

	useEffect(() => {
		if (!selectedFaculty && facultyForUser?.id) {
			setSelectedFaculty(facultyForUser.id as string);
		}
	}, [selectedFaculty, facultyForUser?.id]);

	const resolvedFacultyId = selectedFaculty || facultyForUser?.id || null;
	const selectedFacultyName =
		faculties?.find((faculty) => faculty.id === resolvedFacultyId)
			?.facultyNameRo || "";
	const practiceYearOptions =
		selectedFacultyName === "Facultatea de Inginerie Industrială și Robotică"
			? [StudentYearEnum.L2, StudentYearEnum.L3]
			: [StudentYearEnum.L3];
	const programsFacultyId = isAdmin
		? selectedFaculty ?? null
		: resolvedFacultyId;

	const { data: programs } = useQuery(
		[getPrograms, programsFacultyId],
		() =>
			programsFacultyId
				? getStudyProgramsForFaculties([programsFacultyId])
				: getReportStudyPrograms(),
		{
			refetchOnWindowFocus: false,
			onError: () =>
				openErrorNotification(
					t("reports.errorTexts.loadingFailed"),
					t("reports.errorTexts.loadingFailedMessage")
				),
		}
	);

	useEffect(() => {
		setFilteredPrograms(
			programs?.filter((program) => {
				const matchesCycle =
					program.studyCycle?.toLowerCase() === studyCycle?.toLowerCase();
				const matchesFaculty = programsFacultyId
					? program.facultyId === programsFacultyId
					: true;
				return matchesCycle && matchesFaculty;
			}) ?? []
		);
		setStudyProgram([]);
	}, [studyCycle, programs, resolvedFacultyId]);

	// Filtrare programe pentru tab "3" bazat pe facultate și ciclu de studii
	const allocatedProjectsFilteredPrograms =
		programs?.filter(
			(program) =>
				program.studyCycle?.toLowerCase() === studyCycle?.toLowerCase() &&
				(!resolvedFacultyId || program.facultyId === resolvedFacultyId)
		) ?? [];

	// Filtrare programe pentru tab "5" bazat pe facultate și anul de studiu
	const practiceFilteredPrograms =
		programs?.filter(
			(program) =>
				program.studyCycle?.toLowerCase() === "bachelor" &&
				(!resolvedFacultyId || program.facultyId === resolvedFacultyId)
		) ?? [];

	// Resetare program când se schimbă ciclul de studii, anul universitar sau facultatea pentru tab "3"
	useEffect(() => {
		if (tab === "3") {
			setAllocatedProjectsStudyProgram(undefined);
		}
	}, [studyCycle, selectedYear, resolvedFacultyId, tab]);

	// Resetare program când se schimbă anul de studiu, anul universitar sau facultatea pentru tab "5"
	useEffect(() => {
		if (tab === "5") {
			setPracticeStudyProgram(undefined);
		}
	}, [practiceStudyYear, selectedYear, resolvedFacultyId, tab]);

	useEffect(() => {
		if (!practiceYearOptions.includes(practiceStudyYear)) {
			setPracticeStudyYear(StudentYearEnum.L3);
		}
	}, [practiceYearOptions, practiceStudyYear]);

	useEffect(() => {
		if (tab === "4" || tab === "5") {
			setStudyCycle("Bachelor");
		}
	}, [tab]);

	// Prefiltrare inițială pe baza rolului
	useEffect(() => {
		if (currentUser) {
			// Director de departament: prefiltrare pe departamentul său
			if (isDepartmentDirector && currentUser.departmentId) {
				setSelectedDepartments(currentUser.departmentId);
			}
			// Decan/Vicedean: prefiltrare pe facultatea sa
			if (isDean && currentUser.faculty?.id) {
				setSelectedFaculty(currentUser.faculty.id);
			}
			// Faculty Admin: prefiltrare pe facultatea sa
			if (isFacultyAdmin && currentUser.faculty?.id) {
				setSelectedFaculty(currentUser.faculty.id);
			}
			// Admin: prefiltrare pe facultatea sa (dacă are)
			if (isAdmin && currentUser.faculty?.id) {
				setSelectedFaculty(currentUser.faculty.id);
			}
		}
	}, [currentUser, isDepartmentDirector, isDean, isFacultyAdmin, isAdmin]);

	// Resetare departamente când se schimbă facultatea (admin sau decan)
	useEffect(() => {
		if ((isAdmin || isDean) && selectedFaculty) {
			setSelectedDepartments(emptyGuid);
		}
	}, [selectedFaculty, isAdmin, isDean]);

	// Setare departamente pentru decan când se încarcă departmentsData
	useEffect(() => {
		if (isDean && departmentsData && departmentsData.length > 0) {
			// Setăm "Toate" (emptyGuid) pentru decan
			setSelectedDepartments(emptyGuid);
		}
	}, [departmentsData, isDean]);

	const getOldValues = () => {
		if (location.state !== undefined) {
			let { activeTab }: any = location.state;

			setTab(activeTab);

			history.replace({ ...history.location, state: undefined });
		}
	};

	useBeforeRender(() => getOldValues(), [location]);

	return (
		<div className="px-4 flex flex-col gap-4 py-10">
			<div className="flex flex-wrap items-center gap-2">
				{tab !== "4" && tab !== "5" && tab !== "6" && tab !== "7" && (
					<Select
						defaultValue={studyCycle}
						options={[
							{ label: t("reports.bachelors"), value: "Bachelor" },
							{ label: t("reports.masters"), value: "Master" },
						]}
						onChange={setStudyCycle}
					/>
				)}
				{
					<Select
						defaultValue={selectedYear}
						value={selectedYear}
						onChange={setSelectedYear}
						placeholder={t("reports.year")}
					>
						{[...Array(5)].map((_, index) => {
							const year = getCurrentUniversityYear() - index;
							return (
								<Option key={year} value={year}>
									{year} - {year + 1}
								</Option>
							);
						})}
					</Select>
				}
				{(tab === "5" || tab === "6" || tab === "7" || tab === "8") && (
					<Select
						defaultValue={internshipType}
						options={[
							{ label: t("reports.allOffers"), value: null },
							{
								label: t("reports.facultyOffers"),
								value: InternshipType.ByProfessor,
							},
							{
								label: t("reports.companyOffers"),
								value: InternshipType.ByCompany,
							},
						]}
						onChange={setInternshipType}
					/>
				)}
				{isAdmin && faculties && (
					<Select
						value={selectedFaculty}
						placeholder={t("reports.faculty")}
						onChange={setSelectedFaculty}
						allowClear
						style={{ width: "350px" }}
					>
						{(tab === "6" || tab === "7") && (
							<Option value={emptyGuid}>{t("reports.all")}</Option>
						)}
						{faculties?.map((faculty: any) => (
							<Option key={faculty.id} value={faculty.id}>
								{faculty.facultyNameRo}
							</Option>
						))}
					</Select>
				)}
				{(tab === "4" || tab === "5") && (
					<Select
						value={practiceStudyYear}
						placeholder={t("reports.year")}
						onChange={setPracticeStudyYear}
						style={{ width: "150px" }}
					>
						{practiceYearOptions.map((year) => (
							<Option key={year} value={year}>
								{`${t("reports.year")} ${year.replace("L", "")}`}
							</Option>
						))}
					</Select>
				)}
				{tab === "5" && (
					<Select
						value={practiceStudyProgram}
						placeholder={t("reports.studyProgram")}
						onChange={setPracticeStudyProgram}
						allowClear
						style={{ width: "250px" }}
					>
						<Option value={emptyGuid}>{t("reports.all")}</Option>
						{practiceFilteredPrograms?.map((program) => (
							<Option key={program.id} value={program.name}>
								{program.name}
							</Option>
						))}
					</Select>
				)}
				{tab === "3" && (isDean || isDepartmentDirector || isAdmin) && (
					<>
						{/* Filtru program de învățământ cu opțiunea "Toate" */}
						<Select
							value={allocatedProjectsStudyProgram}
							placeholder={t("reports.studyProgram")}
							onChange={setAllocatedProjectsStudyProgram}
							allowClear
							style={{ width: "250px" }}
						>
							<Option value={emptyGuid}>{t("reports.all")}</Option>
							{allocatedProjectsFilteredPrograms?.map((program) => (
								<Option key={program.id} value={program.name}>
									{program.name}
								</Option>
							))}
						</Select>
					</>
				)}

				{tab !== "1" &&
					tab !== "3" &&
					tab !== "5" &&
					tab !== "6" &&
					tab !== "7" &&
					programs &&
					programs.length > 1 && (
						<Select
							showSearch
							allowClear
							onChange={setStudyProgram}
							style={{ width: "250px" }}
							placeholder={t("reports.studyProgram")}
							value={studyProgram}
						>
							{filteredPrograms?.map((program) => (
								<Option key={program.id} value={program.name}>
									{program.name}
								</Option>
							))}
						</Select>
					)}
				{/* Filtre specifice pentru raportul profesori */}
				{tab === "1" && (isDean || isDepartmentDirector || isAdmin) && (
					<>
						{/* Filtru departamente - pentru decan și admin */}
						{(isDean || isAdmin) && (
							<Select
								value={selectedDepartments}
								onChange={setSelectedDepartments}
								showSearch
								style={{ width: "38em" }}
								placeholder={t("reports.departments")}
								filterOption={(input, option) =>
									String(option?.children || "")
										.toLowerCase()
										.includes(input.toLowerCase())
								}
							>
								<Option value={emptyGuid}>{t("reports.all")}</Option>
								{departmentsData?.map((department: any) => (
									<Option key={department.id} value={department.id}>
										{department.departmentNameRo || department.departmentNameEn}
									</Option>
								))}
							</Select>
						)}
					</>
				)}
			</div>

			<Tabs activeKey={tab} onChange={setTab}>
				{/* Raport profesori - vizibil pentru FacultyAdmin, Dean, DepartmentDirector, Admin */}
				{(isDean || isDepartmentDirector || isAdmin) &&
					((selectedStudyCycle === "Bachelor" &&
						isAcademicUsersBachelorInternshipEnabled) ||
						(selectedStudyCycle === "Master" &&
							isAcademicUsersMasterInternshipEnabled) ||
						(selectedStudyCycle === "All" &&
							(isAcademicUsersBachelorInternshipEnabled ||
								isAcademicUsersMasterInternshipEnabled)) ||
						// Fallback pentru compatibilitate cu logica veche
						(studyCycle === "Bachelor" &&
							isAcademicUsersBachelorInternshipEnabled &&
							!selectedStudyCycle) ||
						(studyCycle === "Master" &&
							isAcademicUsersMasterInternshipEnabled &&
							!selectedStudyCycle)) && (
						<TabPane tab={t("reports.professorReport")} key="1">
							<ReportTable
								getCall={getProfessorProposalReport}
								args={[
									// Determinăm engagementType pe baza selectedStudyCycle sau studyCycle
									selectedStudyCycle === "Master" ||
									(selectedStudyCycle === "All" && studyCycle === "Master") ||
									(!selectedStudyCycle && studyCycle === "Master")
										? InternshipEngagementType.MastersInternship
										: InternshipEngagementType.BachelorsInternship,
									studyProgram,
									selectedYear,
									selectedFaculty,
									selectedDepartments ? [selectedDepartments] : [emptyGuid],
									selectedStudyCycle,
								]}
								columns={professorReportColumns(t).filter(
									(item) => !item?.hidden
								)}
								reportColumns={professorReportColumns(t)}
								queryKey={getProfessorProposalReportInfo}
								watchChanges={[
									studyCycle,
									selectedYear,
									selectedFaculty,
									selectedDepartments,
									selectedStudyCycle,
								]}
								fileName={t("files.professorReport")}
							/>
						</TabPane>
					)}
				{(isAcademicUsersBachelorInternshipEnabled ||
					isAcademicUsersMasterInternshipEnabled) &&
					(isDean || isAdmin || isDepartmentDirector) && (
						<TabPane
							tab={t("reports.missingStudentProjectEnrollmentReport")}
							key="2"
						>
							<ReportTable
								getCall={getMissingStudentProjectEnrollmentReport}
								args={[studyCycle, selectedYear, selectedFaculty, studyProgram]}
								columns={missingStudentProjectEnrollmentReportColumns(t).filter(
									(item) => !item?.hidden
								)}
								reportColumns={missingStudentProjectEnrollmentReportColumns(t)}
								queryKey={getMissingStudentProjectEnrollmentReportInfo}
								watchChanges={[
									studyCycle,
									selectedYear,
									studyProgram,
									selectedFaculty,
								]}
								fileName={t("files.missingStudentProjectEnrollmentReport")}
							/>
						</TabPane>
					)}
				{/* Raport proiecte alocate - vizibil pentru Dean/ViceDean + Director de departament + Admin (NU pentru FacultyAdmin) */}
				{(isDean || isDepartmentDirector || isAdmin) &&
					(isAcademicUsersBachelorInternshipEnabled ||
						isAcademicUsersMasterInternshipEnabled) && (
						<TabPane tab={t("reports.allocatedProjectsReport")} key="3">
							<ReportTable
								getCall={getProjectAllocationReport}
								args={[
									selectedStudyCycle === "Master" ||
									(selectedStudyCycle === "All" && studyCycle === "Master") ||
									(!selectedStudyCycle && studyCycle === "Master")
										? InternshipEngagementType.MastersInternship
										: InternshipEngagementType.BachelorsInternship,
									allocatedProjectsStudyProgram &&
									allocatedProjectsStudyProgram !== emptyGuid
										? [allocatedProjectsStudyProgram]
										: [],
									selectedYear,
									isAdmin ? selectedFaculty : resolvedFacultyId,
								]}
								columns={projectAllocationReportColumns(t).filter(
									(item) => !item?.hidden
								)}
								reportColumns={projectAllocationReportColumns(t)}
								queryKey={getProjectAllocationReportInfo}
								watchChanges={
									tab === "3"
										? [
												studyCycle,
												allocatedProjectsStudyProgram,
												selectedYear,
												isAdmin ? selectedFaculty : resolvedFacultyId,
										  ]
										: []
								}
								fileName={t("files.allocatedProjectsReport")}
							/>
						</TabPane>
					)}
				{(isAdmin || isDean || isDepartmentDirector || isFacultyAdmin) && (
					<TabPane
						tab={t("reports.missingStudentPracticeInternshipEnrollmentReport")}
						key="4"
					>
						<ReportTable
							getCall={getMissingStudentPracticeInternshipEnrollmentReport}
							args={[
								practiceStudyYear,
								studyProgram,
								selectedYear,
								resolvedFacultyId,
							]}
							columns={missingStudentPracticeEnrollmentReportColumns(t).filter(
								(item) => !item?.hidden
							)}
							reportColumns={missingStudentPracticeEnrollmentReportColumns(t)}
							queryKey={getMissingStudentPracticeInternshipEnrollmentReportInfo}
							watchChanges={[
								studyProgram,
								practiceStudyYear,
								selectedYear,
								resolvedFacultyId,
							]}
							fileName={t(
								"files.missingStudentPracticeInternshipEnrollmentReport"
							)}
						/>
					</TabPane>
				)}
				<TabPane tab={t("reports.allocatedPracticeInternshipsReport")} key="5">
					<ReportTable
						getCall={getPracticeInternshipAllocationReport}
						args={[
							practiceStudyProgram && practiceStudyProgram !== emptyGuid
								? [practiceStudyProgram]
								: [],
							internshipType !== null ? internshipType : undefined,
							selectedYear,
							isAdmin ? selectedFaculty : resolvedFacultyId,
							practiceStudyYear,
						]}
						columns={practiceInternshipAllocationReportColumns(t).filter(
							(item) => !item?.hidden
						)}
						reportColumns={practiceInternshipAllocationReportColumns(t)}
						queryKey={getPracticeInternshipAllocationReportInfo}
						watchChanges={[
							practiceStudyProgram,
							internshipType,
							selectedYear,
							isAdmin ? selectedFaculty : resolvedFacultyId,
							practiceStudyYear,
						]}
						fileName={t("files.allocatedPracticeInternshipsReport")}
					/>
				</TabPane>
				<TabPane tab={t("reports.studentAllocationPerDomainReport")} key="6">
					<ReportTable
						getCall={getStudentAllocationPerDomainReport}
						args={[internshipType, selectedYear, selectedFaculty]}
						columns={studentAllocationPerDomainReportColumns(t)}
						reportColumns={studentAllocationPerDomainReportColumns(t)}
						queryKey={getStudentAllocationPerDomainReportInfo}
						watchChanges={[internshipType, selectedYear, selectedFaculty]}
						fileName={t("files.studentAllocationPerDomainReport")}
					/>
				</TabPane>
				{(isDean || isDepartmentDirector || isFacultyAdmin || isAdmin) && (
					<TabPane
						tab={t("reports.practiceInternshipsPerDomainReport")}
						key="7"
					>
						<ReportTable
							getCall={getPracticeInternshipPerDomainReport}
							args={[
								internshipType !== null ? internshipType : undefined,
								selectedYear,
								isAdmin
									? selectedFaculty && selectedFaculty !== emptyGuid
										? selectedFaculty
										: undefined
									: resolvedFacultyId,
							]}
							columns={practiceInternshipsPerDomainReportColumns(t)}
							reportColumns={practiceInternshipsPerDomainReportColumns(t)}
							queryKey={getPracticeInternshipPerDomainReportInfo}
							watchChanges={[
								internshipType,
								selectedYear,
								isAdmin ? selectedFaculty : resolvedFacultyId,
							]}
							fileName={t("files.practiceInternshipsPerDomainReport")}
						/>
					</TabPane>
				)}
				{isAcademicUsersSummerSchoolEnabled &&
					(isDean || isAdmin || isDepartmentDirector) && (
						<TabPane tab={t("reports.summerSchoolsReport")} key="8">
							<ReportTable
								getCall={getSummerSchoolsReport}
								args={[
									studyProgram,
									selectedYear,
									selectedFaculty,
									internshipType,
									studyCycle,
								]}
								columns={summerSchoolsReportColumns(t)}
								reportColumns={summerSchoolsReportColumns(t)}
								queryKey={getSummerSchoolReportInfo}
								watchChanges={[
									selectedYear,
									studyProgram,
									selectedFaculty,
									internshipType,
									studyCycle,
								]}
								fileName={t("files.summerSchoolReport")}
							/>
						</TabPane>
					)}
			</Tabs>
		</div>
	);
};

export default Report;
